import { Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { AbstractDialog, AbstractDialogData, DialogComponent } from '@next/core-lib/dialog';
import { TranslatePipe } from '@next/core-lib/i18n';

export interface DiseaseExplainDialogData extends AbstractDialogData {
  imagePath: string;
  diseaseName: string;
}

@Component({
    selector: 'app-disease-explain-dialog',
    templateUrl: './disease-explain-dialog.component.html',
    imports: [DialogComponent, TranslatePipe],
})
export class DiseaseExplainDialogComponent extends AbstractDialog {  protected mdDialogRef = inject<MatDialogRef<DiseaseExplainDialogComponent>>(MatDialogRef);
  data = inject<DiseaseExplainDialogData>(MAT_DIALOG_DATA);

}
